import { useState } from "react";
import { toast } from "sonner";
import { postWaitlist } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { ArrowRight } from "lucide-react";

export const WaitlistForm = ({ source = "homepage", compact = false, placeholder = "Your email address" }) => {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!email) return;
    setBusy(true);
    try {
      const res = await postWaitlist({ email, source });
      toast.success(res.message || "You're on the list!");
      setEmail("");
    } catch {
      toast.error("Please enter a valid email address.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <form onSubmit={submit} data-testid={`waitlist-form-${source}`} className="flex items-center gap-2 w-full max-w-md">
      <Input
        type="email"
        required
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        placeholder={placeholder}
        data-testid={`waitlist-email-${source}`}
        className="rounded-full border-secondary bg-white/80 h-12 px-5 focus-visible:ring-maroon"
      />
      <button
        type="submit"
        disabled={busy}
        data-testid={`waitlist-submit-${source}`}
        className="shrink-0 h-12 rounded-full bg-maroon text-cream hover:bg-maroon-dark transition-transform hover:-translate-y-0.5 disabled:opacity-60 flex items-center justify-center px-5"
      >
        {compact ? <ArrowRight className="w-4 h-4" strokeWidth={2} /> : <span className="px-1">Join</span>}
      </button>
    </form>
  );
};
